import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router =  new Router({
  mode: 'history', // 去掉url中的#
  //如果部署到子目录需要修改成vue.config.js  publicPath配置一样 
  base: 'web-gov',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '',
      component: () => import('@/views/index.vue'),
      redirect: '/home',
      children: [
        {
          path: '/home',
          component: () => import('@/views/home'),
          name: 'Index',
          meta:{
            title:'首页'
          }
        },
        {
          path: "/hot",
          name:"hot",
          component: () => import("@/views/hot.vue"), 
          meta:{
            title:'热点话题'
          }
        },
        {
          path: "/course",
          name:"course",
          component: () => import("@/views/course.vue"), 
          meta:{
            title:'守护课程'
          }
        },
        {
          path: "/reply",
          name:"reply",
          component: () => import("@/views/reply/index.vue"), 
          meta:{
            title:'树洞'
          }
        },
        {
          path: "/question",
          name:"reply",
          component: () => import("@/views/reply/question.vue"), 
        },
        {
          path: "/replyDetail",
          name:"reply",
          component: () => import("@/views/reply/detail.vue"), 
        },
        {
          path: "/test",
          name:"test",
          component: () => import("@/views/test.vue"), 
        },
        {
          path: "/activityDetail",
          name:"activityDetail",
          component: () => import("@/views/activityDetail.vue"), 
          meta:{
            title:'详情'
          }
        },
        {
          path: "/exam",
          name:"exam",
          component: () => import("@/views/exam.vue"), 
        },
        {
          path: "/consult",
          name:"consult",
          component: () => import("@/views/consult.vue"), 
          meta:{
            title:'在线咨询'
          }
        },
        {
          path: "/volunteer",
          name:"volunteer",
          component: () => import("@/views/volunteer.vue"), 
        },
        {
          path: "/my",
          name:"my",
          component: () => import("@/views/my/my.vue"), 
        },
        {
          path: "/volMy",
          name:"volMy",
          component: () => import("@/views/my/volMy.vue"), 
        },
        {
          path: "/interview",
          name:"interview",
          component: () => import("@/views/interview.vue"), 
        },
        {
          path: "/resume",
          name:"resume",
          component: () => import("@/views/resume.vue"), 
        },
        {
          path: "/notice",
          name:"notice",
          component: () => import("@/views/notice.vue"), 
        },
        {
          path: "/share",
          name:"share",
          component: () => import("@/views/share.vue"), 
        },
        {
          path: "/study",
          name:"study",
          component: () => import("@/views/study/index.vue"), 
        },
        {
          path: "/studyDetail",
          name:"studyDetail",
          component: () => import("@/views/study/detail.vue"), 
        },
        {
          path: "/taskDetail",
          name:"taskDetail",
          component: () => import("@/views/study/myTaskDetail.vue"), 
        },

        
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register.vue')
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('@/views/forget.vue')
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   // 全局前置守卫逻辑
//   const token = localStorage.getItem('web_token') // 假设token存储在localStorage中
//   if (!token) {
//     console.log('111')
//     // 如果页面需要认证，但是没有token，则重定向到登录页
//     next({ path: '/login' })
//   } else {
//     console.log('22')
//     // 否则，继续正常的页面跳转
//     next()
//   }
// });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js